'use client'

import {
  type PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react'

interface PaginationContextProps {
  maybePage: number | undefined
  page: number
  urlHash: string | undefined
  setPage: (pageNumber: number) => void
}

const defaultContextValues: PaginationContextProps = {
  maybePage: undefined,
  page: Number.NaN,
  urlHash: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setPage: () => {},
}

const PaginationContext =
  createContext<PaginationContextProps>(defaultContextValues)

export const PaginationProvider = ({
  children,
  urlHash,
}: PropsWithChildren & { urlHash?: string }) => {
  const [maybePage, setPage] = useState<number | undefined>()

  const context: PaginationContextProps = {
    maybePage,
    page: maybePage ?? Number.NaN,
    urlHash,
    setPage,
  }

  return (
    <PaginationContext.Provider value={context}>
      {children}
    </PaginationContext.Provider>
  )
}

export const usePaginationContext = (
  initial?: number,
): PaginationContextProps => {
  const context = useContext(PaginationContext)
  return { ...context, page: context.maybePage ?? initial ?? 1 }
}
